<template>
  <v-container fluid class="d-none">
    <v-row class="px-0 py-0 my-0">

      <v-row class="px-7 pb-0 pt-6">
        <v-col cols="12" md="6" lg="2" class="pa-0 mr-auto filter-min-width" v-for="e in autocompleteСards" :key="e.value">
          <v-autocomplete
              dense
              v-model="filtered[`${e.filtered}`]"
              :items="filters[`${e.filters}`]"
              :menu-props="{ maxHeight: '200' }"
              multiple
              outlined
              :class="['mr-md-1', {'v-input--is-focused primary--text' : filtered[`${e.filtered}`].length}]"
              @change="fetchFilters"
              :placeholder="e.placeholder"
          >

          </v-autocomplete>
        </v-col>

        <v-btn class="mr-4 white--text " @click="HandlerCreateNewContact" color="indigo" id="id_btn_create_new_contact">Create New</v-btn>

          <v-dialog  max-width="800px" v-model="isShowCreateNewContact" >

            <RuralActivityForm :id-contact="null" :crutch-d-t="tmp_timestamp" v-on:closeModal="closeModal"></RuralActivityForm>

          </v-dialog>

      </v-row>



      <v-spacer></v-spacer>

      <v-col cols="7" md="3" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">
        <div id="Excel_dwn_wrapper" name="excel_report_download_calls" class="mt-5">

          <div name="excel_report_download_summary" >
            <div>
              <vue-excel-xlsx
                  :data="dataReportSummary4Excel"
                  :columns="columnsDataSummary"
                  :filename="`Fo_Contacts.xlsx`"
                  :sheetname="`report`"
              >
                <v-btn
                    height="39"
                    min-width="39px"
                    class="ml-auto mr-5 rounded-lg pa-0 ma-0"
                    color="white"
                >
                  <ExportExcel/>
                </v-btn>
              </vue-excel-xlsx>


            </div>
          </div>

        </div>
        <div id="custom_columns_config" class="mt-5">
          <CustomColumns
              :currentValue="ConfigMenuValue"
              :currentCustomHeader="customHeader"
              :currentHeaders="headers"
              :settingsName="settingsName"
              @getCustomData="getCustomData"
          />
        </div>

      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <v-row class="px-4 pb-0 pt-3">
      <v-col cols="10" sm="5" class="pb-0 pl-0">
        <v-text-field id="id_search_element"
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-col>
      <v-btn
          color="indigo"
          class="mt-3"
          dark
          depressed
          height='40'
          max-width='40'
          min-width='40'
          @click="cleanFilters"
      >
        <v-icon>
          mdi-autorenew
        </v-icon>
      </v-btn>
    </v-row>

    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg d-none">
      <v-progress-linear
          indeterminate
          color="blue darken-2"
          v-if="loaded"
      ></v-progress-linear>
      <v-row class="pa-0">
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">

          </div>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">

          </div>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">

          </div>
        </v-col>
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="d-flex flex-column">

          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2 py-0 px-2 mt-4 rounded-lg d-none">
      <v-row class="px-4 pb-0 pt-3">
        <v-col cols="10" sm="5" class="pb-0">
          <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              outlined
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-col>
        <v-btn
            color="indigo"
            class="mt-3"
            dark
            depressed
            height='40'
            max-width='40'
            min-width='40'
            @click="cleanFilters"
        >
          <v-icon>
            mdi-autorenew
          </v-icon>
        </v-btn>
      </v-row>

    </v-card>
    <v-card class="elevation-2 py-0 px-0 mt-4 rounded-lg">
      <v-card-title>
        <v-row class="pa-0">
          <v-col cols="12" class="d-flex justify-end pb-0 pt-0 mt-0 mt-md-4">
            <v-spacer></v-spacer>

          </v-col>
        </v-row>
      </v-card-title>
      <v-col cols="7" md="3" sm="9" class="d-flex justify-end pb-0 pt-0 mt-0">


      </v-col>
      <v-hover v-model="hoverOnTable">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <v-btn v-if="false"
                class="mx-2 scroll-btn btn-left-arrow"
                fab
                small
                @click="scrollingLeft"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-btn v-if="false"
                class="mx-2 scroll-btn btn-right-arrow"
                fab
                small
                @click="scrollingRight"
            >
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <v-data-table
              :footer-props="{
                  'items-per-page-options': [10, 25, 50, 75, 100, -1]
                  }"
              :items-per-page="25"
              dense
              :headers="selectedHeaders"
              :items="dataFiltered"
              :page.sync="pagination.page"
              item-key="id"
              class="elevation-0 mt-2 table-main-container"
              :loading="loaded"
              loading-text="Loading... Please wait"

              fixed-header
              height="609"

          >
            <!--  events table  -->
            <template v-slot:item.Events="{ item }">

              <v-dialog  max-width="1200px" @input="onDialogChange" v-on:closeModal="closeModalEventsModal">
                <template v-slot:activator="{ on }" >

                  <button v-on="on"  type="button" class="button btn btn-primary pl-2 pr-2" @click="handlerEditContact(item.Id)">
                    <span>Events {{item.Events}}</span>
                  </button>

                </template>
                <v-card>
                  <v-card-title v-if="!isShowAddEvent">
                    <span class="headline">Events</span>
                    <div class="form-width ml-5 w-50">
                      <v-btn  class="mr-4 white--text form-width  mt-3 w80"
                              @click="addEventHandler" color="indigo" block >
                        Add Event
                      </v-btn>
                      <div class="mt-5">  </div>
                    </div>

                  </v-card-title>

                  <v-data-table v-if="!isShowAddEvent"

                      dense
                      :headers="headerEventsTable"
                      :items="currentAcitivitysLog"
                      item-key="id"
                      class="elevation-0 mt-2 table-main-container"
                      fixed-header

                  >
                    <template v-slot:item.EditAction="{ item }">

                      <button  type="button" class="button btn btn-primary pr-3 pl-3"
                              @click="handler_edit_event(item.id)">
                        <span>Edit</span>
                      </button>

                    </template>
                    <template v-slot:item.DeleteAction="{ item }">
                      <button type="button" class="button btn btn-primary pr-3 pl-3"
                              @click="handler_delete_event(item)">
                        <span>Delete</span>
                      </button>

                    </template>

                  </v-data-table>

                  <div v-if="isShowAddEvent" class="form-width pt-5" id="open_event_add_form">
                    <RuralEvent4ContactForm :contact_id="item.Id"
                                            :event_id="event_id_4_edit"
                                            @endAddedEvents="handler_endCreateEvent"
                    ></RuralEvent4ContactForm>
                    <div class="mt-5 footer-empty-hieght">   </div>
                  </div>


                </v-card>
              </v-dialog>

            </template>
            <template v-slot:item.EditAction="{ item }">

              <v-dialog  max-width="1000px" v-model="dialogOpenFlags[item.index]" >
                <template v-slot:activator="{ on }"  >

                  <button v-on="on"  type="button" class="button btn btn-primary pr-3 pl-3"
                          @click="handlerEditContact(item.Id)">
                    <span>Edit</span>
                  </button>
                </template>
                <RuralActivityForm :id-contact="item.Id" v-on:closeModal="closeModal"></RuralActivityForm>

              </v-dialog>

            </template>
            <template v-slot:item.Address="{item}" class="addres-item-width">
              <span class="addres-item-width">{{item.Address}}</span>
            </template>

            <template v-slot:item.DeleteAction="{ item }">

              <v-dialog  max-width="800px" v-model="dialogDelOpenFlags[item.index]" >
                <template v-slot:activator="{ on }"  >

                  <button v-on="on"  type="button" class="button btn btn-primary pr-3 pl-3"
                          @click="handleDeleteClick(item.Id)">
                    <span>Del</span>
                  </button>
                </template>
                <RuralContactDeleteForm :id-contact="item.Id" v-on:closeModal="closeDelModal"></RuralContactDeleteForm>

              </v-dialog>

            </template>

          </v-data-table>
        </v-card-text>
      </v-hover>
    </v-card>
  </v-container>
</template>


<script>

import axios from '@/api/axios-auth'

// import LastTimeUpdated from "@/views/LastTimeUpdated.vue";
import RuralActivityForm from "../Forms/RuralContactForm.vue"
import RuralContactDeleteForm from "../Forms/RuralContactDeleteForm.vue"
import ExportExcel from "@/components/customizing/ExportExcel.vue";
import CustomColumns from "@/components/customizing/CustomColumns.vue";
import RuralEvent4ContactForm from "@/views/Forms/RuralEvent4ContactForm.vue";
import instance from "@/api/axios-auth";
import RuralEventType_Helper from "@/utils/Load_RuralEventType";
import { EventBus } from '@/utils/EventBus';
import {AccesTokenGUID, ClientFingerPring} from "@/utils/ClientFingerPring";

export default {
  name: "ruralBuildOffContacts",

  components: {RuralEvent4ContactForm, CustomColumns,  RuralActivityForm,RuralContactDeleteForm,ExportExcel},
  data: function () {
    // window.location.href = 'http://stage.sellnetics.com';
    return {
      contactsData:[],
      contactDataFiltered:[],
      currentAcitivitysLog:[],
      columnsDataSummary:[],
      eventTypeHelper:new RuralEventType_Helper(),
      headerEventsTable:[
        {text: 'Name', value: 'name', class: 'black--text', filterable: false, sortable: true},
        {text: 'Type', value: 'TypePrintable', class: 'black--text', filterable: false, sortable: true},
        {text: 'Call Id', value: 'call_id', class: 'black--text', filterable: false, sortable: true},
        {text: 'WebInquiry', value: 'web_inquiry_id', class: 'black--text', filterable: false, sortable: true},
        {text: 'Note', value: 'note', class: 'black--text', filterable: false, sortable: true},
        // {text: 'Email Campaing', value: 'EmailCompaign', class: 'black--text', filterable: false, sortable: true},
        //{text: 'SpecLink', value: 'SpecLink', class: 'black--text', filterable: false, sortable: true},
        //{text: 'Get Certified', value: 'isCertExists', class: 'black--text', filterable: false, sortable: true},
        {text: 'Date', value: 'date_event', class: 'black--text', filterable: false, sortable: true},
        //{text: 'Edit', value: 'EditAction', class: 'black--text'},
        {text: 'Del', value: 'DeleteAction', class: 'black--text'},

    ],
      disabled:false,
      id_elem_selected:null,
      isShowAddEvent:false,
      event_id_4_edit:null,
      dialog_edit_contact:false,
      dialog_del_open:false,
      search: '',
      filter_option_old:null,
      hoverOnTable: false,
      loaded: false,
      hiddenAdditionalFilters: true,
      tmp_timestamp:0,
      pagination: {
        page: 1
      },
      dialogOpenFlags:[],
      dialogDelOpenFlags:[],
      isShowCreateNewContact:false,
      onOpenEdit:false,
      statistic: {
        totalOrders: 0,
        totalGallons: 0,
        totalSalesPrice: 0,
        totalExpenses: 0
      },
      statisticFiltered: {
        totalOrders: 0,
        totalGallons: 0,
        totalSalesPrice: 0
      },
      selectedHeaders: [],
      SelectedValues:[],

      autocompleteСards: [
        {name: 'Events Type', filtered: 'event_types', filters: 'event_types',placeholder:"Events"}
        ,{name: 'Segments', filtered: 'segments', filters: 'segments',placeholder:"Segments"}

      ],

      filters: {
        'event_types': [],
        'segments':[],
      },
      ConfigMenuValue: [
        {text: 'Name', value: 'Name', class: 'black--text', filterable: false, sortable: true},
        {text:'Events',value:'Events', class:'black--text'},
        {text:'Segments', value: 'SegmentValue',class:'black--text'},
        {text:'Other Segment', value: 'ClientSegmentOther',class:'black--text'},
        {text:'EventsInfo', value:'EventsValues',class:'black--text'},
        {text: 'Title', value: 'Title', class: 'black--text'},
        {text: 'Address', value: 'Address', class: 'black--text'},
        {text: 'Company', value: 'Organization', class: 'black--text'},
        {text: 'Phone', value: 'Phone', class: 'black--text'},
        // {text: 'Fax', value: 'Fax', class: 'black--text'},
        {text: 'Email', value: 'Email', class: 'black--text'},
        // {text: 'Website', value: 'Website', class: 'black--text'},
        {text: 'Company Website', value: 'CompanyWebsite', class: 'black--text'},
        {text: 'LinkedinUrl', value: 'LinkedinUrl', class: 'black--text'},
        {text: 'Company Linkedin', value: 'LinkedinCompany', class: 'black--text'},

      ],


      defaultHeader_value: [
        {text: 'Name', value: 'Name', class: 'black--text', filterable: false, sortable: true},
        {text:'Events',value:'Events', class:'black--text'},
        {text:'Segments', value: 'SegmentValue',class:'black--text'},
        {text:'Other Segment', value: 'ClientSegmentOther',class:'black--text'},
        {text:'EventsInfo', value:'EventsValues',class:'black--text'},
        {text: 'Title', value: 'Title', class: 'black--text'},
        {text: 'Address', value: 'Address', class: 'black--text'},
        {text: 'Company', value: 'Organization', class: 'black--text'},
        {text: 'Phone', value: 'Phone', class: 'black--text'},
        // {text: 'Fax', value: 'Fax', class: 'black--text'},
        {text: 'Email', value: 'Email', class: 'black--text'},
        // {text: 'Website', value: 'Website', class: 'black--text'},
        {text: 'Company Website', value: 'CompanyWebsite', class: 'black--text'},
        {text: 'LinkedinUrl', value: 'LinkedinUrl', class: 'black--text'},
        {text: 'Company Linkedin', value: 'LinkedinCompany', class: 'black--text'},
          {text: 'Edit', value: 'EditAction', class: 'black--text'},
        {text: 'Del', value: 'DeleteAction', class: 'black--text'},
      ],
      header_item_Always:[
        {text: 'Edit', value: 'EditAction', class: 'black--text'},
        {text: 'Del', value: 'DeleteAction', class: 'black--text'},

      ],
      customHeader: ['Name','Events', 'SegmentValue','ClientSegmentOther', 'EventsValues', 'Title', 'Address','Organization','Phone','Email','CompanyWebsite','LinkedinUrl','LinkedinCompany'],
      filtered: {
        'event_types': [],
        'segments':[],
      },


      headers: [
        {text: 'Name', value: 'Name', class: 'black--text', filterable: false, sortable: true},
        {text:'Events',value:'Events', class:'black--text'},
        {text:'Segments', value: 'SegmentValue',class:'black--text'},
        {text:'Other Segment', value: 'ClientSegmentOther',class:'black--text'},
        {text:'EventsInfo', value:'EventsValues',class:'black--text'},
        {text: 'Title', value: 'Title', class: 'black--text'},
        {text: 'Address', value: 'Address', class: 'black--text'},
        {text: 'Company', value: 'Organization', class: 'black--text'},
        {text: 'Phone', value: 'Phone', class: 'black--text'},
        // {text: 'Fax', value: 'Fax', class: 'black--text'},
        {text: 'Email', value: 'Email', class: 'black--text'},
        {text: 'Company Website', value: 'CompanyWebsite', class: 'black--text'},
        {text: 'LinkedinUrl', value: 'LinkedinUrl', class: 'black--text'},
        {text: 'Company Linkedin', value: 'LinkedinCompany', class: 'black--text'},
        {text: 'Edit', value: 'EditAction', class: 'black--text'},
        {text: 'Del', value: 'DeleteAction', class: 'black--text'},
      ],
      settingsName: 'ruralContactsSettings',
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
          Date.UTC(
              new Date().getFullYear(),
              new Date().getMonth(),
              1)).toISOString().substr(0, 10),
    }
  },
  created() {

    const finger_print = ClientFingerPring()
    const token_uid = AccesTokenGUID()
    // eslint-disable-next-line no-debugger
    //alert('asdfaf')
    //alert(finger_print)
    //alert(token_uid)
    // eslint-disable-next-line no-debugger
    axios.post('/rural/add-login-by-request', {
      'finger_print': finger_print,
      'token_unic': token_uid,
    })
        .then(response => {
            console.log(response.data)
          this.redirectToSellnetics(token_uid)

        })
        .catch(error => {
          console.log(error);
        });


    /*
    window.location.href = 'http://stage.sellnetics.com';
    this.loadContacstData();

     */

    this.selectedHeaders = this.defaultHeader_value;

    },
  methods: {

    redirectToSellnetics(guid){
      // window.location.href// = 'http://stage.sellnetics.com';
      let url = `http://sellnetics.com/sellnetics-av18/login-request?guid=${guid}`;
      window.open(url, '_blank');
      //window.location.href = url
      this.loadContacstData(url)
    },

    // @app.route('/rural/contacts-builoffic',methods=['GET'])
    loadContacstData(){
      this.contactsData = [];
      this.contactDataFiltered = this.contactsData;
      this.fetchFilters()
      axios.get('/rural/contacts-builoffic')
          .then((resp)=>{
            this.contactsData = resp.data.data
            this.addFeature4Data_Segments(this.contactsData)
            this.addFeature4Data_Events(this.contactsData)
            this.contactsData.forEach( (el, index)=>{
              el['Events']='';
              el['EditAction'] = true;
              el['showmodal']=  false;
              el['index'] = index;
              el['DeleteAction'] = true;
              this.dialogOpenFlags.push(false);
              this.dialogDelOpenFlags.push(false);
            });
            this.contactDataFiltered = this.contactsData;
          })
    },
    closeModal() {

      this.dialogOpenFlags = this.dialogOpenFlags.map(el=>el&&false);
      this.isShowCreateNewContact = false;
      this.loadContacstData();
    },
    closeDelModal(){
      this.dialogDelOpenFlags = this.dialogDelOpenFlags.map(el=>el&&false);
      this.loadContacstData();
    },
    loadActivity4Contact(contactid){
      this.currentAcitivitysLog = []
      axios.get('/rurel/contact-activities/' + contactid)
          .then((resp)=>{
            /*
            call_id: null
            created_at: null
            data_json: null
            date_event: "2024-08-10T00:00:00"
            deleted_at: true
            id: 1
            modified_at: null
            name: "Scrap Data"
            type_id: 2
            phoneNumber:'143214124'
            IsLinkedingContact:False
            isCertExists:False
            EmailCompaign:"CampaignName"
            * */

            this.currentAcitivitysLog = resp.data.data
            let moment = require('moment');
            this.currentAcitivitysLog.forEach(el=>{
              el.TypePrintable = this.eventIdToEventName( el.type_id )

              let date = moment(el.date_event);
              el.date_event = date.format('MM/DD/YYYY, h:mm:ss a');
            })
          });
    },
    getCustomData({customHeader, value, selectedHeaders}) {

      // this.customHeader = customHeader;

      this.SelectedValues = value;
      this.selectedHeaders = []
      this.SelectedValues.forEach(el=>{
        const find_el = this.defaultHeader_value.find(sel_el=>sel_el.text === el.text)
        if (find_el){
          this.selectedHeaders.push(el);
        }

      })
      this.header_item_Always.forEach(el=>{
        const find_el = this.SelectedValues.find(sel_el=>sel_el.text === el.text)
        if (!find_el){
          this.selectedHeaders.push(el);
        }

      })
      console.log(selectedHeaders)
      console.log(customHeader)
      //console.log(selectedHeaders)
      //console.log(selected_value);
    },
    cleanFilters() {
      this.search = '';
    },


    scrollingRight() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft + 50

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (el.scrollLeft + el.clientWidth != el.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },
    scrollingLeft() {
      const el = document.querySelector('.v-data-table__wrapper')

      el.scrollLeft = el.scrollLeft - 50

      const btnLeft = document.querySelector('.btn-left-arrow')
      const btnRight = document.querySelector('.btn-right-arrow')
      btnLeft.style.visibility = (this.hoverOnTable && (el.scrollLeft != 0)) ? 'visible' : 'hidden'
      btnRight.style.visibility = this.hoverOnTable ? 'visible' : 'hidden'
    },

    showScrollingArrows() {
      const el = document.querySelector('.v-data-table__wrapper')
      this.scrollLeft = el.scrollLeft
      this.scrollWidth = el.scrollWidth
      this.clientWidth = el.clientWidth

      const btnRight = document.querySelector('.btn-right-arrow')
      const btnLeft = document.querySelector('.btn-left-arrow')
      btnRight.style.visibility = (this.hoverOnTable && (this.scrollLeft + this.clientWidth !== this.scrollWidth)) ? 'visible' : 'hidden'
      btnLeft.style.visibility = (this.hoverOnTable && (this.scrollLeft != 0)) ? 'visible' : 'hidden'
    },

    handlerEditContact(idelement){

      this.id_elem_selected = idelement;
      this.tmp_timestamp = Date.now();
      this.loadActivity4Contact(idelement);
    },

    handler_edit_event(id_event){
      if (id_event){
        this.event_id_4_edit = id_event
        this.tmp_timestamp = Date.now();
        this.isShowAddEvent = true;
      }

     console.log(id_event);
     //this.load_event_data(id_event)
    },


    handler_delete_event(id_event){
      let paylod = {'contact_id':this.id_elem_selected, 'event_id':id_event.id};
      instance.post('/rural/delete-event4contact/', paylod ).then(response => {
        console.log(response.data)
        this.loadActivity4Contact(this.id_elem_selected);
      });
      // alert('Delete call eventid:'+ id_event + ' selecdt_item:' + this.id_elem_selected)
      return;
    },

    handleDeleteClick(idelement){
      this.dialog_del_open = true;
      console.log(idelement)
    },

    initFilters(){
      this.filters.event_types = this.eventTypeHelper.MakeSelectorData()
      /*
      this.filters.event_types=[
        {text:'Call', value:'1'}
        ,{text:'Scrapping', value:'2'}
        ,{text:'Lunch and Learn', value:'3'}
        ,{text:'Coupon', value:'4'}
          ,{text:'Web Inquery', value:'5'}
      ]*/
      this.filters.event_types.sort((a, b) => a.text.localeCompare(b.text));

      this.filters.segments = [
        {text: 'Architect/Designer', value: 2},
        {text: 'Building Officials', value: 3},
        {text: 'Applicators', value: 4},
        {text: 'General Contractors', value: 5},
        {text: 'Engineers', value: 6},
        {text: 'Other', value: 7},
        {text: 'Fire Marshals', value: 9},
        {text: 'Retailers', value: 11},
        {text: 'OEM Companies', value: 12},
        {text: 'Building Owner', value: 15},
        {text: 'Real Estate', value: 16},
        {text: 'Inspectors', value: 19},
        {text: 'Research Partners', value: 20}
      ];

      this.filters.segments.sort((a, b) => a.text.localeCompare(b.text));

    },

    isHasIntersectAnd(list1, list_full){
      list1 = list1.map(el=>el.toString())
      list_full = list_full.map(el=>el.toString())

      for (let i = 0; i < list_full.length; i++) {
        let item = list_full[i];
        if (!list1.includes(item)) return false;
      }
      return true;
    },
    isHasIntersectOr(list1, list_full){
      list1 = list1.map(el=>el.toString())
      list_full = list_full.map(el=>el.toString())

      for (let i = 0; i < list_full.length; i++) {
        let item = list_full[i];
        if (list1.includes(item)) return true;
      }
      return false;
    },

    fetchFilters(select_optrions) {
      console.log(select_optrions)
      this.filter_option_old = select_optrions
      this.applyFiltersAll()
    },
    getUniqueArray(arr) {
      let res = [...new Set(arr)].sort();
      return res;
    },
    arraysEqual(a, b) {
      a = this.getUniqueArray(a)
      b = this.getUniqueArray(b)
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    },

    applyFiltersAll(){
      // select_optrions = this.filter_option_old
      this.contactDataFiltered = this.contactsData;

      if(this.filtered.event_types.length>0){
        this.contactDataFiltered = []
        this.contactsData.forEach(cont=>{
          let evfilterd = this.filtered.event_types.map(Number)
          /*
          if (this.arraysEqual(cont.EventsIds, evfilterd  )){
            this.contactDataFiltered.push(cont)
          }*/

          if (this.isHasIntersectAnd(cont.EventsIds, evfilterd)){
            this.contactDataFiltered.push(cont)
          }
        })
      }

      if(this.filtered.segments.length>0){
        let new_contactDataFiltered = [];


        this.contactDataFiltered.forEach(cont=>{
          if (this.isHasIntersectOr(cont.SegmentIds, this.filtered.segments)){
            new_contactDataFiltered.push(cont)
          }
        })
        this.contactDataFiltered = new_contactDataFiltered
      }
      this.filterByEmail()

    },

    filterByEmail() {
      this.contactDataFiltered = this.contactDataFiltered.filter(cont => {
        let res = false
        if (cont.Email){
          res = cont.Email.includes(this.search)
        }
        if (cont.Phone){
          res = res || cont.Phone.includes(this.search)
        }

        return res
      });

    },

    eventIdToEventName(id){
      return this.eventTypeHelper.Id2Value(id);
      /*
      let res = ''
      if(id==1){
        res = 'Call'
      } else if(id==2){
        res = 'Scrapping'
      }else if(id==3){
        res = 'Lunch&Learn'
      }else if(id==4){
        res = 'COUPON'
      }else if (id==5){
        res="WebInquery"
      }
      return res;*/
    },

    addFeature4Data_Events(data){
      for(let i=0;i<data.length;i++){

        let eventMaps = new Map()
        for (let j=0;j<data[i].EventsIds.length;j++){
          let  eventname = this.eventIdToEventName(data[i].EventsIds[j])
          if ( eventMaps.has(eventname)){
            eventMaps.set(eventname, eventMaps.get(eventname) +1)
          }else{
            eventMaps.set(eventname,1)
          }
        }
        let events_str = []
        for (let [key, value] of eventMaps.entries()) {
          events_str.push(key + '-'+value)
        }
        let seg_str = events_str.join(', ')
        data[i].EventsValues = seg_str;
      }// for
    },
    HandlerCreateNewContact(){
      this.tmp_timestamp =Date.now();
        this.isShowCreateNewContact = true;
    },

    addFeature4Data_Segments(data){
      for(let i=0;i<data.length;i++){
        let segments = []
        for (let j=0;j<data[i].SegmentIds.length;j++){
          const segid = data[i].SegmentIds[j]
          let  segname = ""
          if (segid == 2) {
            segname = 'Architect/Designer';
          } else if (segid == 3) {
            segname = 'Building Officials';
          } else if (segid == 4) {
            segname = 'Applicators';
          } else if (segid == 5) {
            segname = 'General Contractors';
          } else if (segid == 6) {
            segname = 'Engineers';
          } else if (segid == 7) {
            segname = 'Other';
          } else if (segid == 9) {
            segname = 'Fire Marshals';
          } else if (segid == 11) {
            segname = 'Retailers';
          } else if (segid == 12) {
            segname = 'OEM Companies';
          } else if (segid == 15) {
            segname = 'Building Owner';
          } else if (segid == 16) {
            segname = 'Real Estate';
          } else if (segid == 19) {
            segname = 'Inspectors';
          } else if (segid == 20) {
            segname = 'Research Partners';
          } else {
            segname = 'Unknown Segment';
          }
          if (segname){
            segments.push( segname )
          }
        }

        let seg_str = segments.join(', ')
        data[i].SegmentValue = seg_str;
      }// for
    },

    getHeaderForExcel(){
      const coll_names_summary = ["Name", "SegmentValue", "EventsValues", "Title", "Address", "Organization", "Phone", "Fax", "Email", "Website", "LinkedinUrl",'LinkedinCompany'];
      const mapFieldsNames = new Map();
      mapFieldsNames.set('Name','Name');
      // mapFieldsNames.set('Events','Events');
      mapFieldsNames.set('SegmentValue','Segment Value');
      mapFieldsNames.set('EventsValues','Events Values');
      mapFieldsNames.set('Title','Title');
      mapFieldsNames.set('Address','Address');
      mapFieldsNames.set('Organization','Company');
      mapFieldsNames.set('Phone','Phone');
      mapFieldsNames.set('Fax','Fax');
      mapFieldsNames.set('Email','Email');
      mapFieldsNames.set('Website','Website');
      mapFieldsNames.set('LinkedinUrl','LinkedinUrl');
      mapFieldsNames.set('LinkedinCompany','Linkedin Company');
      const mapFieldsSummary = new Map(mapFieldsNames)

      this.columnsDataSummary = coll_names_summary.map(e=>{
        const obj = {}
        obj.label = mapFieldsSummary.get(e)
        obj.field = e
        return obj
      }).filter(value => Object.keys(value).length !== 0);
      console.log(this.columnsDataSummary)
    },
    handler_endCreateEvent(){
      this.isShowAddEvent = false;

      //console.log(EventBus)
      EventBus.$emit('dataChanged')
      if (this.id_elem_selected){
        this.loadActivity4Contact(this.id_elem_selected);
      }

    },
    addEventHandler(){

      this.isShowAddEvent = true;
      // this.axios.post()
    },

    onDialogChange(isVisible) {
      if (!isVisible) {
        this.handleDialogClose();
      }
    },
    handleDialogClose() {
      this.isShowAddEvent = false;
      this.loadContacstData();
      // Your logic to handle dialog close
    },

    closeModalEventsModal(){

    },
    DataReloadRequest(){

      this.loadContacstData()
    },



  },
  mounted() {
    this.getHeaderForExcel();
    EventBus.$on('dataChanged', this.DataReloadRequest);
  },
  watch:{

      dataFiltered: function () {
        this.pagination.page = 1
      },

    search() {        
      this.applyFiltersAll(this.search)
    }
  },
  computed: {
    dataFiltered() {
      return this.contactDataFiltered;
    },
    dataReportSummary4Excel(){
      if (!this.contactDataFiltered) return []
      let data = JSON.parse(JSON.stringify(this.contactDataFiltered))
      return data

    },

  }

}
</script>


<style scoped>
.button {
  display: inline-block;
  padding: 2px 2px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: #3c78d8;
  border: none;
  border-radius: 5px;
  box-shadow: None;
}

.button:hover {background-color: #4747d3}

.button:active {
  background-color: #388aed;
  box-shadow: 0 2px #666;
  transform: translateY(1px);
}

.filter-min-width{
  min-width: 300px;
}

.addres-item-width{
  min-width: 200px;
  display: inline-block;
}
.form-width{
  max-width: 99%;
}
.footer-empty-hieght{
  min-height: 20px;
}
</style>
